const resize = (container) => {
  const productImagesPlaceholder = container.querySelector('[data-product-images-placeholder]');
  const productImagesCarouselActive = container.querySelector('.ProductImages__carousel--active');
  const productImagesDotsPlaceholder = container.querySelector('[data-product-images-dots-placeholder]');
  const productImagesThumbsActive = container.querySelector('.ProductImages__thumbs--active');
  const productImagesThumbsPlaceholder = container.querySelector('[data-product-images-thumbs-placeholder]');
  const productImagesThumbs = container.querySelector('[data-product-images-thumbs]');

  if (productImagesPlaceholder && productImagesCarouselActive) {
    productImagesPlaceholder.style.height = `${productImagesCarouselActive.offsetHeight}px`;
  }

  // Only set the dots placeholder height if the dots are being shown (not a "single" carousel)
  if (
    productImagesCarouselActive &&
    productImagesCarouselActive.classList.contains('ProductImages__carousel--single')
  ) {
    if (productImagesDotsPlaceholder) {
      productImagesDotsPlaceholder.style.height = '0';
    }
  } else {
    if (productImagesDotsPlaceholder) {
      productImagesDotsPlaceholder.style.height = '';
    }
  }

  // Only set the thumbs placeholder height if the thumbs are being shown (not empty)
  if (productImagesThumbsActive && productImagesThumbsActive.classList.contains('ProductImages__thumbs--empty')) {
    if (productImagesThumbsPlaceholder) {
      productImagesThumbsPlaceholder.style.height = '0';
    }
  } else {
    if (productImagesThumbsPlaceholder && productImagesThumbs) {
      productImagesThumbsPlaceholder.style.height = `${productImagesThumbs.offsetHeight}px`;
    }
  }
};

export default function () {
  window.addEventListener('resize', () => {
    const productOverviewContainer = document.querySelector('[data-section-id="INF-ProductOverview"]');
    const quickViewContainer = document.querySelector('[data-section-id="QuickView"]');

    if (productOverviewContainer) {
      resize(productOverviewContainer);
    }

    if (quickViewContainer) {
      resize(quickViewContainer);
    }
  });
}
